"use client";

import React from "react";

import { createSVGIcon } from "../util";

import { IPaymentMethodsIconProps } from "./IPaymentMethodsIconProps";

// https://docs.adyen.com/online-payments/api-only/downloading-logos

/** @optimized using svgo:^3.0.2 */
const SquareLogo = createSVGIcon(
  <>
    <path
      d="M3 .25h34A2.75 2.75 0 0 1 39.75 3v34A2.75 2.75 0 0 1 37 39.75H3A2.75 2.75 0 0 1 .25 37V3A2.75 2.75 0 0 1 3 .25Z"
      fill="#fff"
      stroke="#AAA"
      strokeWidth=".5"
    />
    <path d="M16.133 26.309h7.74v-12.59h-7.74v12.59" fill="#F06022" />
    <path
      d="M16.93 20.018a7.93 7.93 0 0 1 3.07-6.29 8.02 8.02 0 0 0-10.65.65 7.96 7.96 0 0 0 0 11.28 8.02 8.02 0 0 0 10.65.65 8.02 8.02 0 0 1-3.07-6.29"
      fill="#EA1D25"
    />
    <path
      d="M33 20.017c0 2.12-.84 4.15-2.34 5.65a8.1 8.1 0 0 1-10.66.64 8.05 8.05 0 0 0 3.07-6.29 7.96 7.96 0 0 0-3.07-6.29 8.02 8.02 0 0 1 10.66.64 7.93 7.93 0 0 1 2.34 5.65"
      fill="#F79D1D"
    />
  </>,
  "MasterCardSquare",
  {
    viewBox: "0 0 40 40",
    titleAccess: "Square MasterCard Icon",
    fill: "none",
  }
);

/** @optimized using svgo:^3.0.2 */
const Logo = createSVGIcon(
  <>
    <path
      d="M3 .25h34A2.75 2.75 0 0 1 39.75 3v20A2.75 2.75 0 0 1 37 25.75H3A2.75 2.75 0 0 1 .25 23V3A2.75 2.75 0 0 1 3 .25Z"
      fill="#fff"
      stroke="#AAA"
      strokeWidth=".5"
    />
    <path d="M16.129 19.29h7.74V6.7h-7.74v12.59" fill="#F06022" />
    <path
      d="M16.93 13A7.93 7.93 0 0 1 20 6.71a8.02 8.02 0 0 0-10.65.65 7.96 7.96 0 0 0 0 11.28 8.02 8.02 0 0 0 10.65.65A8.02 8.02 0 0 1 16.93 13"
      fill="#EA1D25"
    />
    <path
      d="M33 13c0 2.12-.84 4.15-2.34 5.65a8.1 8.1 0 0 1-10.66.64A8.05 8.05 0 0 0 23.07 13 7.96 7.96 0 0 0 20 6.71a8.02 8.02 0 0 1 10.66.64A7.93 7.93 0 0 1 33 13"
      fill="#F79D1D"
    />
    <rect
      x=".25"
      y=".25"
      width="39.5"
      height="25.5"
      rx="2.75"
      stroke="#AAA"
      strokeWidth=".5"
    />
  </>,
  "MasterCard",
  {
    viewBox: "0 0 40 26",
    titleAccess: "MasterCard Icon",
    fill: "none",
  }
);

export const MasterCard = React.memo(
  ({
    square,
    monochrome,
    ref,
    ...props
  }: IPaymentMethodsIconProps & React.RefAttributes<SVGElement>) => {
    const Icon = square ? SquareLogo : Logo;
    return <Icon ref={ref} {...props} />;
  }
);
